import api from "./api";
import config from "../config";

export default {
  fetchLedgerTransactions(apiKey, { order }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `ledger/transactions`,
          qs: {
            order
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchLedgerAnalyticsTransactions(apiKey, conditions, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/transactions`,
          qs: {
            conditions: JSON.stringify(conditions),
            options: JSON.stringify(options)
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchLedgerBoxOfficeTransactions(apiKey, conditions, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/box_office_transactions`,
          qs: {
            conditions: JSON.stringify(conditions),
            options: JSON.stringify(options)
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchLedgerVenueTransactions(apiKey, conditions, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/venue_transactions`,
          qs: {
            conditions: JSON.stringify(conditions),
            options: JSON.stringify(options)
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchLedgerVenueReport(apiKey, conditions, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/venue_report`,
          qs: {
            conditions: JSON.stringify(conditions),
            options: JSON.stringify(options)
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchLedgerBoxOfficeReport(apiKey, conditions, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/box_office_report`,
          qs: {
            conditions: JSON.stringify(conditions),
            options: JSON.stringify(options)
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchLedgerTransactionReport(apiKey, conditions, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/ledger_transaction_report`,
          qs: {
            conditions: JSON.stringify(conditions),
            options: JSON.stringify(options)
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/LedgerUtil.js